import React, { useMemo } from 'react';
import { Loading as LoadingTFC } from 'tfc-components';

import mapModifiers from 'utils/functions';

interface LoadingProps {
  width?: number;
  variant?: 'fullscreen' | 'default' | 'abs';
  colorLoading?: 'primary' | 'secondary';
}

const Loading: React.FC<LoadingProps> = ({ width = 30, variant = 'default', colorLoading = 'primary' }) => {
  const widthVariant = useMemo(() => {
    if (!width && variant === 'default') return 30;
    if (!width && variant === 'fullscreen') return 50;
    return width;
  }, [width, variant]);

  const color = useMemo(() => {
    if (colorLoading === 'primary') return '#344054';
    if (colorLoading === 'secondary') return '#f69320';
    return '#fff';
  }, [colorLoading]);

  return (
    <div className={mapModifiers('a-loading', variant)}>
      <div style={{ marginLeft: `-${(widthVariant || 30) / 2}px` }}>
        <LoadingTFC.CircleDashed width={width} color={color} />
      </div>
    </div>
  );
};

export default Loading;
